import { parseISO } from "date-fns";
export const timeRangesOverlap = (a, b) => ((a.start < b.start && b.start < a.end) ||
    (a.start < b.end && b.end < a.end) ||
    (b.start < a.start && a.end < b.end) ||
    (b.start <= a.start && a.start < b.end));
export const elementTimeRange = (el) => {
    const start = el.dataset.startTime !== undefined ? parseISO(el.dataset.startTime) : undefined;
    if (start === undefined || isNaN(start.getTime())) {
        return undefined;
    }
    const end = el.dataset.endTime !== undefined ? parseISO(el.dataset.endTime) : undefined;
    if (end === undefined || isNaN(end.getTime())) {
        return undefined;
    }
    return { start, end };
};
//# sourceMappingURL=time-range.js.map